import type { DataMatrixCodeSizeMm } from '@/types/label-template';

const DATA_MATRIX_CODE_MM: readonly DataMatrixCodeSizeMm[] = [20, 25, 30];

export function snapDataMatrixCodeSizeMm(n: number): DataMatrixCodeSizeMm {
  return DATA_MATRIX_CODE_MM.reduce((best, current) =>
    Math.abs(current - n) < Math.abs(best - n) ? current : best,
  DATA_MATRIX_CODE_MM[1],
  );
}
